var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pb-10" },
    [
      _c(
        "div",
        {
          staticClass:
            "flex flex-row justify-between mb-2 items-center flex-wrap",
        },
        [
          _c(
            "h1",
            {
              staticClass:
                "text-heading font-semibold font-outfit leading-10 mt-4",
            },
            [_vm._v(" " + _vm._s(_vm.topHeading) + " ")]
          ),
          _c(
            "div",
            { staticClass: "flex flex-row pt-4 flex-wrap" },
            [
              _vm.showDownload
                ? _c("ProjectDataDownloader", {
                    staticClass: "mr-2",
                    attrs: { company: _vm.company },
                  })
                : _vm._e(),
              _vm.showDownload
                ? _c("UIButton", {
                    staticClass: "ml-4 font-outfit",
                    attrs: {
                      buttonText: "Add new client",
                      variant: "black",
                      size: "lg",
                    },
                    on: { click: _vm.toggle },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "icon",
                          fn: function () {
                            return [_c("PlusIcon", { staticClass: "w-4 h-4" })]
                          },
                          proxy: true,
                        },
                        {
                          key: "hover-icon",
                          fn: function () {
                            return [
                              _c("HoveredIcon", { staticClass: "w-6 h-6" }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3681370335
                    ),
                  })
                : _vm._e(),
              _vm.showNewVisit
                ? _c("UIButton", {
                    staticClass: "font-outfit mr-2",
                    attrs: {
                      variant: "black",
                      buttonText: "Create New Visit",
                      size: "lg",
                    },
                    on: { click: _vm.openActivityModal },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "icon",
                          fn: function () {
                            return [_c("PlusIcon", { staticClass: "w-4 h-4" })]
                          },
                          proxy: true,
                        },
                        {
                          key: "hover-icon",
                          fn: function () {
                            return [
                              _c("HoveredIcon", { staticClass: "w-6 h-6" }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3681370335
                    ),
                  })
                : _vm._e(),
              _vm.showNewVisit
                ? _c("UIButton", {
                    staticClass: "font-outfit smart-match-btn",
                    attrs: {
                      variant: "outline",
                      buttonText: "Smart Match Config",
                      size: "lg",
                    },
                    on: { click: _vm.openSmartMatchModal },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "icon",
                          fn: function () {
                            return [
                              _c(
                                "svg",
                                {
                                  staticClass: "lucide lucide-settings w-4 h-4",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "aria-hidden": "true",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
                                    },
                                  }),
                                  _c("circle", {
                                    attrs: { cx: "12", cy: "12", r: "3" },
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "hover-icon",
                          fn: function () {
                            return [
                              _c(
                                "svg",
                                {
                                  staticClass: "lucide lucide-settings w-4 h-4",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "#000000",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "aria-hidden": "true",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
                                    },
                                  }),
                                  _c("circle", {
                                    attrs: { cx: "12", cy: "12", r: "3" },
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      612167061
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm.dialog
        ? _c("ClientEditModal", {
            attrs: {
              dialog: _vm.dialog,
              companyId: _vm.company.id,
              currentUserId: _vm.currentUser.id,
              currentUser: _vm.currentUser,
              activeTab: _vm.activeTab,
              initialData: {},
              isCareplanExist: false,
              isEdit: false,
              currentEditTab: _vm.currentEditTab,
            },
            on: { closeDialog: _vm.hanldeCancel, close: _vm.handleClose },
          })
        : _vm._e(),
      _vm.activityModalOpened
        ? _c("ActivityFormModal", {
            attrs: {
              currentUserRole: _vm.userRole,
              companyId: _vm.company.id,
              currentUserId: _vm.currentUser.id,
              showProject: true,
            },
            on: {
              activityUpdated: _vm.onActivityListItemAdded,
              activityAdded: _vm.onActivityListItemAdded,
              close: function ($event) {
                _vm.activityModalOpened = false
              },
            },
            model: {
              value: _vm.activityModalOpened,
              callback: function ($$v) {
                _vm.activityModalOpened = $$v
              },
              expression: "activityModalOpened",
            },
          })
        : _vm._e(),
      _vm.smartMatchModalOpened
        ? _c("SmartMatchConfigModal", {
            attrs: {
              companyId: _vm.company.id,
              currentUserId: _vm.currentUser.id,
              currentUser: _vm.currentUser,
            },
            on: {
              close: function ($event) {
                _vm.smartMatchModalOpened = false
              },
            },
            model: {
              value: _vm.smartMatchModalOpened,
              callback: function ($$v) {
                _vm.smartMatchModalOpened = $$v
              },
              expression: "smartMatchModalOpened",
            },
          })
        : _vm._e(),
      _c("router-view", {
        attrs: {
          company: _vm.company,
          currentUser: _vm.currentUser,
          onActivityListItemAdded: _vm.onActivityListItemAdded,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }